import React from 'react';
import { Grid, Typography, Link } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import studyClasses from './studyStyles';
import { Link as RouterLink } from 'react-router-dom';

function StudyRelated() {
  const globalClasses = globalUseStyles()
  const studyStyles = studyClasses()

  return (
  <ThemeProvider theme={theme}>
    <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
        <Grid className={globalClasses.containerSmall} container >
            <Grid item xs={12} md={12}  >
                <Typography  align="center" variant="h2">Related Case Studies</Typography>
            </Grid>
        </Grid>
        <Grid className={globalClasses.containerSmall} container spacing={4}>
            <Grid item className={globalClasses.topBottomSpacing} xs={12} md={4}  >
                  <Grid item xs={12} md={12} className={studyStyles.rciImg} />
                <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                <div className={globalClasses.tagYellow}>
                    <Typography variant="subtitle2">Custom Application</Typography>
                </div>
                <div className={globalClasses.tagYellow}>
                    <Typography variant="subtitle2">Reporting and Analytics</Typography>
                </div>
                </Grid>
                <Grid className={globalClasses.paddingTop} item xs={12} md={12}  >
                <Typography className={globalClasses.cardMargin}  variant="h4">The Rosalyn Carter Institute for Caregivers (RCI)</Typography>
                <Typography variant="body1">The Rosalyn Carter Institute for Caregivers (RCI) promotes the health, strength, and resilience of caregivers at every stage of their journey. We developed a caregiver management system to document and report on the caregiver experience with RCI across every program and touchpoint. </Typography>
                <Typography variant="body1" >
                <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                          </Link>
                  </Typography>
                </Grid>
            </Grid>
            <Grid item className={globalClasses.topBottomSpacing} xs={12} md={4}  >
                  <Grid item xs={12} md={12} className={studyStyles.ashaImg} />
                <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}>
                <div className={globalClasses.tagYellow}>
                    <Typography variant="subtitle2">Custom Application</Typography>
                </div>
                <div className={globalClasses.tagYellow}>
                    <Typography variant="subtitle2">Reporting and Analytics</Typography>
                </div>
                </Grid>
                <Grid className={globalClasses.paddingTop} item xs={12} md={12}  >
                <Typography className={globalClasses.cardMargin}  variant="h4">ASHA’s National Outcomes Measurement System (NOMS)</Typography>
                <Typography variant="body1">ASHA NOMS is a data collection and reporting system that demonstrates the value of Speech-Language Pathology and audiology services. Integrated with EHRs, this tool allows providers to track progress in patients and aggregates data so that the field can make informed decisions on patient outcomes. </Typography>
                <Typography variant="body1" >
                <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                          </Link>
                    </Typography>
                </Grid>
            </Grid>
            <Grid item className={globalClasses.topBottomSpacing} xs={12} md={4}  >
                  <Grid item xs={12} md={12} className={studyStyles.ahrqImg} />
                <Grid className={globalClasses.textBlockBelow} item xs={12} md={12}  >
                <div className={globalClasses.tagYellow}>
                    <Typography variant="subtitle2">Custom Application</Typography>
                </div>
                <div className={globalClasses.tagYellow}>
                    <Typography variant="subtitle2">Reporting and Analytics</Typography>
                </div>
                </Grid>
                <Grid className={globalClasses.paddingTop} item xs={12} md={12}  >
                <Typography className={globalClasses.cardMargin} variant="h4">The Rosalyn Carter Institute for Caregivers (RCI)</Typography>
                <Typography  variant="body1">The Rosalyn Carter Institute for Caregivers (RCI) promotes the health, strength, and resilience of caregivers at every stage of their journey. We developed a caregiver management system to document and report on the caregiver experience with RCI across every program and touchpoint. </Typography>
                <Typography variant="body1" >
                <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                          </Link>
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    </Container>
    </ThemeProvider>
  );
};

export default StudyRelated;